import { Nunito, Inter, JetBrains_Mono, Space_Grotesk } from 'next/font/google';

export const nunito = Nunito({
  weight: ['400', '700'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-nunito',
});

/**
 * Fonts for the admin design system. Each exposes a `--font-*` CSS variable (via
 * next/font) that the `font-admin-*` utilities in the shared Tailwind preset
 * (`config/tailwind-workspace-preset.ts`) reference. Loaded via next/font so they
 * are self-hosted and cause no layout shift.
 */
export const spaceGrotesk = Space_Grotesk({
  // Display / headings: semibold + bold.
  weight: ['600', '700'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-space-grotesk',
});

export const inter = Inter({
  // UI / body: regular, medium, semibold.
  weight: ['400', '500', '600'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-inter',
});

export const jetBrainsMono = JetBrains_Mono({
  // Identifiers: regular + medium (mono rows use font-medium).
  weight: ['400', '500'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-jetbrains-mono',
});

/** Combined class list to apply on the admin root wrapper. */
export const adminFontVariables = [
  spaceGrotesk.variable,
  inter.variable,
  jetBrainsMono.variable,
].join(' ');
